import _asyncToGenerator from "E:/dayinjia/Vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.replace.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-59a0ffad"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "container"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h4", null, "重置密码", -1);
});

var _hoisted_3 = {
  class: "eye"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "back"
  }, [/*#__PURE__*/_createElementVNode("a", {
    href: "javascript:history.go(-1)"
  }, "返回上一步")], -1);
});

import { ref } from 'vue';
import { sendSms, retrieve } from '@/api/login';
import { ElMessage } from 'element-plus';
import router from '@/router';
export default {
  setup: function setup(__props) {
    var form = ref({
      phone: '',
      password: '',
      code: ''
    });
    var formRef = ref(null); // 手机验证

    var validateMobilePhone = function validateMobilePhone(rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不可为空'));
      } else {
        if (value !== '') {
          var reg = /^1[3456789]\d{9}$/;

          if (!reg.test(value)) {
            callback(new Error('请输入有效的手机号码'));
          }
        }

        callback();
      }
    }; // 密码验证


    var validatePass = function validatePass(rule, value, callback) {
      var pwdReg = /^(?=.*\d)(?=.*[a-zA-Z]).{8,}$/;

      if (!value) {
        return callback(new Error('请输入密码'));
      } else if (pwdReg.test(value)) {
        callback();
      } else {
        callback(new Error('请输入包含数字字母的不低于8位数的密码'));
      }
    };

    var rules = ref({
      phone: [{
        required: true,
        validator: validateMobilePhone,
        trigger: 'change'
      }],
      password: [{
        required: true,
        validator: validatePass,
        trigger: 'change'
      }],
      code: [{
        required: true,
        message: '请输入验证码',
        trigger: 'blur'
      }]
    });
    var show = ref(true);
    var timer = ref();
    var TIME_COUNT = ref(60);
    var count = ref();

    var getCode = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reg, phone;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(form.value.phone);
                reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;

                if (!(form.value.phone === '')) {
                  _context.next = 6;
                  break;
                }

                ElMessage.error('请输入手机号码');
                _context.next = 15;
                break;

              case 6:
                if (reg.test(form.value.phone)) {
                  _context.next = 10;
                  break;
                }

                ElMessage.error('手机格式不正确');
                _context.next = 15;
                break;

              case 10:
                if (!timer.value) {
                  count.value = TIME_COUNT.value;
                  show.value = false;
                  timer.value = setInterval(function () {
                    if (count.value > 0 && count.value <= TIME_COUNT.value) {
                      count.value--;
                    } else {
                      show.value = true;
                      clearInterval(timer.value);
                      timer.value = null;
                    }
                  }, 1000);
                }

                phone = form.value.phone;
                _context.next = 14;
                return sendSms(phone);

              case 14:
                ElMessage('已发送，请注意查收');

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCode() {
        return _ref.apply(this, arguments);
      };
    }();

    var passwordType = ref('password');

    var changeType = function changeType() {
      if (passwordType.value === 'password') {
        passwordType.value = 'text';
      } else {
        passwordType.value = 'password';
      }
    };

    var handleResetPassword = function handleResetPassword() {
      formRef.value.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!valid) {
                    _context2.next = 7;
                    break;
                  }

                  _context2.next = 3;
                  return retrieve(form.value);

                case 3:
                  ElMessage('重置成功，请重新登录');
                  router.replace('/login');
                  _context2.next = 9;
                  break;

                case 7:
                  console.log('error submit!');
                  return _context2.abrupt("return", false);

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    };

    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_form_item = _resolveComponent("el-form-item");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_form = _resolveComponent("el-form");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: form.value,
        class: "login-form",
        rules: rules.value
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            prop: "username"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_svg_icon, {
                icon: "user"
              }), _createVNode(_component_el_input, {
                modelValue: form.value.phone,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return form.value.phone = $event;
                }),
                placeholder: "请输入账号"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "password"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_svg_icon, {
                icon: "password"
              }), _createVNode(_component_el_input, {
                modelValue: form.value.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return form.value.password = $event;
                }),
                type: passwordType.value,
                placeholder: "请输入新密码"
              }, null, 8, ["modelValue", "type"]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_svg_icon, {
                icon: passwordType.value === 'password' ? 'eye' : 'eye-open',
                onClick: changeType
              }, null, 8, ["icon"])])];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "code"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_svg_icon, {
                icon: "shield"
              }), _createVNode(_component_el_input, {
                modelValue: form.value.code,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return form.value.code = $event;
                }),
                class: "inputWithButton"
              }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
                plain: ""
              }, {
                default: _withCtx(function () {
                  return [_withDirectives(_createElementVNode("span", {
                    onClick: getCode
                  }, "获取验证码", 512), [[_vShow, show.value]]), _withDirectives(_createElementVNode("span", {
                    class: "count"
                  }, _toDisplayString(count.value) + " s 后获取", 513), [[_vShow, !show.value]])];
                }),
                _: 1
              })];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["model", "rules"]), _createVNode(_component_el_button, {
        type: "primary",
        class: "login-button",
        onClick: handleResetPassword
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t('login.btnResetPwd')), 1)];
        }),
        _: 1
      }), _hoisted_4]);
    };
  }
};